import { CSSProperties } from 'react'

import { MdPlayArrow, MdStop } from 'react-icons/md'

// ヘッダーの再生/停止/リセットと見た目を揃えるため共通スタイルを再利用する。
import '../../components/preview/previewRunControls.css'
import { volumeIcon } from '../../components/preview/volumeIcon'

/**
 * ビューポートの内側左下に再生/停止/リセットをオーバーレイ配置するためのラッパ。
 * three.js の canvas（ビューポート）はマウス操作を受けるため、操作の邪魔に
 * ならないよう左下隅に小さくまとめる。
 */
/** ビューポート下のフッターバー（実行/停止/初期化ボタンを左端に置く）。 */
const footerBarStyle: CSSProperties = {
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: 6,
  padding: '6px 10px',
  background: '#f4f4f8',
}

export interface PreviewControlsBarProps {
  /** 実行中フラグ。実行/停止ボタンの活性状態を切り替える。 */
  running: boolean
  /** 音量(0..1)。アイコン表示とスライダー位置に使う。 */
  volume: number
  /** 実行ボタン押下時のハンドラ。 */
  onStart: () => void
  /** 停止ボタン押下時のハンドラ。 */
  onStop: () => void
  /** 音量スライダー変更時のハンドラ（0..1）。 */
  onVolumeChange: (volume: number) => void
  /** ミュートアイコン押下時のハンドラ（音量 0 と直前音量をトグル）。 */
  onToggleMute: () => void
}

/** ビューポート下のフッターバー（実行/停止/音量）。 */
export function PreviewControlsBar({
  running,
  volume,
  onStart,
  onStop,
  onVolumeChange,
  onToggleMute,
}: PreviewControlsBarProps) {
  const muted = volume <= 0
  return (
    <div className="preview-run-controls" style={footerBarStyle}>
      <button
        type="button"
        className="preview-run-control-button is-start"
        onClick={onStart}
        // 実行中は連続実行を防ぐため無効化。停止/初期化で再び押せる。
        disabled={running}
        aria-label="じっこう"
        title="じっこう"
      >
        <MdPlayArrow size={22} aria-hidden="true" />
      </button>
      <button
        type="button"
        className="preview-run-control-button is-stop"
        onClick={onStop}
        // 停止中（未実行含む）は連打しても意味がないため無効化。
        // 実行ボタンで再び押せる。
        disabled={!running}
        aria-label="ていし"
        title="ていし"
      >
        <MdStop size={20} aria-hidden="true" />
      </button>
      <button
        type="button"
        className="preview-run-control-button is-mute"
        onClick={onToggleMute}
        aria-label={muted ? 'ミュートかいじょ' : 'ミュート'}
        aria-pressed={muted}
        title={muted ? 'ミュートかいじょ' : 'ミュート'}
      >
        {volumeIcon(volume)}
      </button>
      <input
        type="range"
        className="preview-volume-slider"
        min={0}
        max={1}
        step={0.01}
        value={volume}
        onInput={(event) => onVolumeChange(Number(event.currentTarget.value))}
        aria-label="おんりょう"
      />
    </div>
  )
}
